import { render, staticRenderFns } from "./BroilerList.vue?vue&type=template&id=6ca30863&"
import script from "./BroilerList.vue?vue&type=script&lang=js&"
export * from "./BroilerList.vue?vue&type=script&lang=js&"
import style0 from "./BroilerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports